import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpen, ShieldCheck, Sparkles, Users, Wrench } from 'lucide-react';

const CAPABILITIES = [
  { key: 'characteristics', Icon: Sparkles },
  { key: 'knowledge', Icon: BookOpen },
  { key: 'tools', Icon: Wrench },
  { key: 'projects', Icon: Users },
] as const;

const USE_CASE_KEYS = ['support', 'internal', 'specialized', 'tenant'] as const;

export const WorkspaceSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-[#f8fafc] text-slate-950">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 md:grid-cols-2 md:px-8">
        <div>
          <p className="text-sm font-semibold uppercase text-indigo-700">
            {t('landing.workspace.eyebrow')}
          </p>
          <h2 className="mt-3 text-3xl font-bold leading-tight md:text-4xl">
            {t('landing.workspace.title')}
          </h2>
          <p className="mt-4 text-base leading-7 text-slate-600">
            {t('landing.workspace.description')}
          </p>
        </div>

        <div className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
          <div className="mb-5 grid gap-3 sm:grid-cols-2">
            {CAPABILITIES.map(({ key, Icon }) => (
              <div key={key} className="rounded-lg border border-slate-200 p-4">
                <Icon size={18} className="text-indigo-600" />
                <div className="mt-2 text-sm font-semibold">
                  {t(`landing.workspace.capabilities.${key}.label`)}
                </div>
                <p className="mt-1 text-xs leading-5 text-slate-500">
                  {t(`landing.workspace.capabilities.${key}.detail`)}
                </p>
              </div>
            ))}
          </div>
          <div className="mb-3">
            <h3 className="text-lg font-semibold">{t('landing.workspace.useCasesTitle')}</h3>
            <p className="text-sm text-slate-500">{t('landing.workspace.useCasesSubtitle')}</p>
          </div>
          <div className="grid gap-3">
            {USE_CASE_KEYS.map((key) => (
              <div
                key={key}
                className="flex items-start gap-3 rounded-lg border border-slate-200 bg-slate-50 p-4"
              >
                <ShieldCheck size={18} className="mt-0.5 flex-shrink-0 text-emerald-600" />
                <span className="text-sm leading-6 text-slate-700">
                  {t(`landing.workspace.useCases.${key}`)}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
